export default {

    methods: {
        changeObTip(tip) {
            this.$nextTick(() => {
                $('.ob-tooltip.active').removeClass('active');
                $('#ob-' + tip).addClass('active');
                eventBus.$emit('tip-changed', tip)

                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".ob-tooltip.active").offset().top - 100
                }, 1000);
            })
        }
    },

    mounted(){
        let self = this

        $(document).on('click', '.ob-close', function() {
            $(this).parents('.ob-tooltip').removeClass('active');
        });

        $(document).on('click', '.ob-prev', function() {
            var tar = $(this).parents('.ob-tooltip').data('ob') - 1;
            self.changeObTip(tar);
        });

        $(document).on('click', '.ob-next', function() {
            var tar = $(this).parents('.ob-tooltip').data('ob') + 1;
            self.changeObTip(tar);
        });
    }
}
